import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { PriceDuelHero } from './components/PriceDuelHero';
import { BrutalTruth } from './components/BrutalTruth';
import { MakersPoverty } from './components/MakersPoverty';
import { Revelation } from './components/Revelation';
import { MakerProof } from './components/MakerProof';
import { ValueStack } from './components/ValueStack';
import { ProProof } from './components/ProProof';
import { Ultimatum } from './components/Ultimatum';
import { Guarantee } from './components/Guarantee';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { LivePurchaseToast } from './components/LivePurchaseToast';
import { LiveViewersBadge } from './components/LiveViewersBadge';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="3ik7eyd5x05p2">
      <div className="w-full min-h-full bg-cream font-heading text-ink antialiased" data-id="element-1" data-mp="3iiwdwl3utc1n">
        <UrgencyBar data-id="element-2" data-mp="3ml17xky7saot" />
        <main data-id="element-3" data-mp="3mk8710lxsfel">
          <PriceDuelHero data-id="element-4" data-mp="3mjzpuwis6nxl" />
          <BrutalTruth data-id="element-5" data-mp="3mj6j3vjtnyfg" />
          <MakersPoverty data-id="element-6" data-mp="3rbra6pbcfxfa" />
          <Revelation data-id="element-7" data-mp="3rdki07xp0nov" />
          <MakerProof data-id="element-8" data-mp="3rd19fhtxnbni" />
          <ValueStack data-id="element-9" data-mp="5yk6vxnnffx" />
          <ProProof data-id="element-10" data-mp="6hovayao7c0" />
          <Ultimatum data-id="element-11" data-mp="4wyzymxdckh" />
          <Guarantee data-id="element-12" data-mp="56mnfkhz7n0" />
          <FaqSection data-id="element-13" data-mp="7stfczkdj46" />
          <FinalCta data-id="element-14" data-mp="2zllff2q1qmn9" />
        </main>

        <LivePurchaseToast data-id="element-15" data-mp="2zmem63p09c5e" />
        <LiveViewersBadge data-id="element-16" data-mp="2zn678kkz7rhf" />
        <noscript data-id="element-17" data-mp="33mf623uvifju">
          <img height="1" width="1" style={{
          display: 'none'
        }} src="https://www.facebook.com/tr?id=2243850073137099&ev=PageView&noscript=1" alt="" data-id="element-18" data-mp="33lx18iu5at0b" />
        </noscript>
      </div>
    </CountdownProvider>;
}